// src/KlinikDanisanlar.js (Tam Kod)
import React, { useState, useEffect, useCallback } from 'react';
import { Button, Card, Spinner, Alert, Modal } from 'react-bootstrap';
import api from './api';
import KlinikDanisanFormu from './KlinikDanisanFormu';

function KlinikDanisanlar({ theme }) {
  const [danisanlar, setDanisanlar] = useState([]);
  const [diyetisyenler, setDiyetisyenler] = useState([]); // Diyetisyenleri tutmak için yeni state
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [duzenlenenDanisan, setDuzenlenenDanisan] = useState(null);

  const verileriGetir = useCallback(async () => {
    try {
      // Hem danışanları hem de diyetisyenleri aynı anda çek
      const [danisanRes, diyetisyenRes] = await Promise.all([
        api.get('/klinik/danisanlar'),
        api.get('/klinik/diyetisyenler')
      ]);
      setDanisanlar(danisanRes.data);
      setDiyetisyenler(diyetisyenRes.data);
    } catch (err) { setError("Veriler yüklenirken bir hata oluştu."); } 
    finally { setLoading(false); }
  }, []);

  useEffect(() => { verileriGetir(); }, [verileriGetir]);

  const handleFormSubmit = async (formData) => {
    const isUpdating = !!duzenlenenDanisan;
    const url = isUpdating ? `/klinik/danisanlar/${duzenlenenDanisan.id}` : '/klinik/danisanlar';
    const method = isUpdating ? 'put' : 'post';
    try {
      await api[method](url, formData);
      setShowModal(false);
      verileriGetir();
    } catch (err) { alert(`Hata: ${err.response?.data?.mesaj || 'İşlem başarısız'}`); }
  };

  const handleSil = async (danisanId) => {
    if (!window.confirm("Bu danışanı silmek istediğinizden emin misiniz?")) return;
    try {
      await api.delete(`/klinik/danisanlar/${danisanId}`);
      verileriGetir();
    } catch (err) { alert(`Hata: ${err.response?.data?.mesaj || 'Silme başarısız'}`); }
  };

  const handleModalOpen = (danisan = null) => { setDuzenlenenDanisan(danisan); setShowModal(true); };
  const handleModalClose = () => { setDuzenlenenDanisan(null); setShowModal(false); };

  if (loading) return <Spinner animation="border" variant={theme === 'dark' ? 'light' : 'dark'} />;
  if (error) return <Alert variant="danger">{error}</Alert>;

  return (
    <>
      <Card className="glass-card text-white">
        <Card.Body>
          <div className="d-flex justify-content-between align-items-center mb-3">
            <Card.Title as="h2">Klinik Danışanları</Card.Title>
            <Button variant="light" onClick={() => handleModalOpen()}>+ Yeni Danışan Ekle</Button>
          </div>
          <div style={{ overflowX: 'auto' }}>
            <table className="data-table">
              <thead>
                <tr>
                  <th>Ad Soyad</th>
                  <th>E-posta</th>
                  <th>Telefon</th>
                  <th>Atanan Diyetisyen</th>
                  <th className="text-end">İşlemler</th>
                </tr>
              </thead>
              <tbody>
                {danisanlar.map(danisan => (
                  <tr key={danisan.id}>
                    <td data-label="Ad Soyad">{danisan.ad} {danisan.soyad}</td>
                    <td data-label="E-posta">{danisan.eposta || '-'}</td>
                    <td data-label="Telefon">{danisan.telefon || '-'}</td>
                    <td data-label="Atanan Diyetisyen">{danisan.diyetisyen_adi}</td>
                    <td data-label="İşlemler" className="text-end">
                      <Button variant="warning" size="sm" onClick={() => handleModalOpen(danisan)}>Düzenle</Button>
                      <Button variant="danger" size="sm" className="ms-2" onClick={() => handleSil(danisan.id)}>Sil</Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Card.Body>
      </Card>
      <Modal show={showModal} onHide={handleModalClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>{duzenlenenDanisan ? 'Danışan Düzenle' : 'Yeni Danışan Ekle'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <KlinikDanisanFormu 
            mevcutDanisan={duzenlenenDanisan} 
            onFormSubmit={handleFormSubmit} 
            onIptal={handleModalClose}
            diyetisyenler={diyetisyenler} // Diyetisyen listesini forma prop olarak gönder
          />
        </Modal.Body>
      </Modal>
    </>
  );
}
export default KlinikDanisanlar;